export default __webpack_public_path__ + "static/media/SpacerKits.8a62c1ec.pdf";